import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export interface RuleGroupDialogData {
  title: string;
  confirmText: string;
  cancelText: string;
  deleteText?: string;
  isEditMode?: boolean;
  initialName?: string;
  initialOperator?: 'AND' | 'OR';
  initialExemptWeeks?: number;
  initialDaysEntitled?: number;
  initialIsDeterminant?: boolean;
}

export interface RuleGroupDialogResult {
  action: 'save' | 'delete';
  name: string;
  operator: 'AND' | 'OR';
  exempt_weeks?: number;
  days_entitled?: number;
  is_determinant?: boolean;
}

@Component({
  selector: 'app-protocol-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
  ],
  templateUrl: './protocol-dialog.component.html',
  styleUrls: ['./protocol-dialog.component.css', '../../../styles/layout.css'],
})
export class ProtocolDialogComponent {
  // Variables
  title: string;
  confirmText: string;
  cancelText: string;
  deleteText: string;
  isEditMode: boolean;

  // Form fields
  groupName: string = '';
  operator: 'AND' | 'OR' = 'AND';
  exemptWeeks: number = 0;
  daysEntitled: number = 0;
  isDeterminant: boolean = false;

  // Operator choices
  operatorChoices = [
    { value: 'AND', label: 'Se deben cumplir todas las reglas' },
    { value: 'OR', label: 'Se puede elegir cualquiera de las opciones' },
  ];

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<ProtocolDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: RuleGroupDialogData
  ) {
    // Obtener los datos del dialogo
    this.title = data.title;
    this.confirmText = data.confirmText;
    this.cancelText = data.cancelText;
    this.deleteText = data.deleteText || 'Eliminar';
    this.isEditMode = data.isEditMode || false;

    // Set initial values for edit mode
    if (data.initialName) {
      this.groupName = data.initialName;
    }
    if (data.initialOperator) {
      this.operator = data.initialOperator;
    }
    if (data.initialExemptWeeks !== undefined) {
      this.exemptWeeks = data.initialExemptWeeks;
    }
    if (data.initialDaysEntitled !== undefined) {
      this.daysEntitled = data.initialDaysEntitled;
    }
    if (data.initialIsDeterminant !== undefined) {
      this.isDeterminant = data.initialIsDeterminant;
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onDelete() {
    const result: RuleGroupDialogResult = {
      action: 'delete',
      name: this.groupName.trim(),
      operator: this.operator,
      exempt_weeks: this.exemptWeeks,
      days_entitled: this.daysEntitled,
      is_determinant: this.isDeterminant,
    };
    this.dialogRef.close(result);
  }

  onConfirm() {
    if (this.groupName.trim()) {
      const result: RuleGroupDialogResult = {
        action: 'save',
        name: this.groupName.trim(),
        operator: this.operator,
        exempt_weeks: this.exemptWeeks,
        days_entitled: this.daysEntitled,
        is_determinant: this.isDeterminant,
      };
      this.dialogRef.close(result);
    }
  }
}
